 
export const headerCellClassName = 'd-flex justify-content-between align-items-center text-dark';

export const AUTOMATED_PRO_FORMA = 'Automated Pro Forma';
export const MANUAL_SPREADSHEET = 'Manual spreadsheet';

export enum PRO_FORMA_STATUS {
    SUBSTANTIALLY_COMPLETE = 2,
    IN_PROGRESS = 3,
    DRAFT = 4,
}

export const LINKED_TO_PROJECT_BADGE_TEXT = 'Linked to project';

export const PRO_FORMA_STATUS_MAPPING: { [key: number]: { name: string; color: string } } = {
    [PRO_FORMA_STATUS.SUBSTANTIALLY_COMPLETE]: {
        name: 'Substantially complete',
        color: 'success-lighten',
    },
    [PRO_FORMA_STATUS.IN_PROGRESS]: {
        name: 'In progress',
        color: 'warning-lighten',
    },
    [PRO_FORMA_STATUS.DRAFT]: {
        name: 'Draft',
        color: 'dark-lighten',
    },
};

export const PRO_FORMA_DUPLICATE = 'Duplicate';
export const PRO_FORMA_SET_AS_ACTIVE = 'Set as active';
export const PRO_FORMA_DELETE = 'Delete';

export const PRO_FORMA_ELLIPSIS_OPTIONS: { [key: number]: string[] } = {
    [PRO_FORMA_STATUS.SUBSTANTIALLY_COMPLETE]: [PRO_FORMA_DUPLICATE, PRO_FORMA_DELETE],
    [PRO_FORMA_STATUS.IN_PROGRESS]: [PRO_FORMA_DUPLICATE, PRO_FORMA_DELETE],
    [PRO_FORMA_STATUS.DRAFT]: [PRO_FORMA_DELETE],
};

export const PRO_FORMAS_TABLE_HEADERS = [
    {
        key: 'name',
        name: 'Name',
    },
    {
        key: 'proFormaModelId',
        name: 'Asset type',
    },
    {
        key: 'boeScenarioId',
        name: 'Scenario',
    },
    {
        key: 'lastModified',
        name: 'Last modified',
    },
    {
        key: 'createdAt',
        name: 'Date created',
    },
    {
        key: 'createdByName',
        name: 'Created by',
    },
    {
        key: 'proFormaStatusId',
        name: 'Status',
    },
];
